export const pageLoadEvent = 'pageLoad';
export const userSelectionEvent = 'userSelection';
export const autocompleteEvent = 'autocomplete';

export const specialtyType = 'specialty';
export const procedureType = 'procedure';
export const professionalType = 'professional';
export const semanticType = 'semantic';
export const browseSpecialtyType = 'browse_specialty';

export const sectionType = {
    firstSection: 'firstSection',
    secondSection: 'secondSection',
};
